import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

import { cn } from "@/lib/utils";

interface SortButtonProps {
  label: string;
  direction: "asc" | "desc" | null;
  onClick: () => void;
}

export function SortButton({ label, direction, onClick }: SortButtonProps) {
  const Icon =
    direction === "asc" ? ArrowUp : direction === "desc" ? ArrowDown : ArrowUpDown;

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "relative -mx-2 -my-1.5 inline-flex cursor-pointer items-center gap-1.5 rounded-md px-2 py-1.5 transition-colors",
        // An invisible overlay grows the touch target to 44px without
        // changing the header row's height.
        "pointer-coarse:after:absolute pointer-coarse:after:inset-x-0 pointer-coarse:after:-inset-y-2",
        "hover:bg-accent hover:text-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        direction && "text-foreground"
      )}
    >
      {label}
      <Icon className={cn("size-3.5", !direction && "opacity-50")} />
    </button>
  );
}
